module.exports = __webpack_public_path__ + "84bbf01aac41850d3c442c05a899b3a1.png";